import { Archive, Inbox, MessageCircle, Star } from "lucide-react";
import React, { useMemo } from "react";
import { FilterType, HeaderInfo } from "../types";

/**
 * Custom hook to generate dynamic header information based on current filters
 */
export function useHeaderInfo(activeFilter: FilterType): HeaderInfo {
  return useMemo(() => {
    return getTabHeaderInfo(activeFilter);
  }, [activeFilter]);
}

/**
 * Gets header info for tab mode based on active filter
 */
function getTabHeaderInfo(activeFilter: FilterType): HeaderInfo {
  switch (activeFilter) {
    case FilterType.CHATS:
      return {
        title: "Chats",
        description: "Conversations with your assistants",
        icon: React.createElement(MessageCircle),
      };

    case FilterType.STARRED:
      return {
        title: "Starred",
        description: "Your starred items",
        icon: React.createElement(Star),
      };

    case FilterType.ARCHIVED:
      return {
        title: "Archived",
        description: "Your archived items",
        icon: React.createElement(Archive),
      };

    default:
      return getDefaultHeaderInfo();
  }
}

/**
 * Returns default header info for inbox
 */
function getDefaultHeaderInfo(): HeaderInfo {
  return {
    title: "Inbox",
    description: "Items generated by your chats",
    icon: React.createElement(Inbox),
  };
}
